// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1RKe5","rootSuccess":"CompleteLink_rootSuccess__2QmUL","rootFailure":"CompleteLink_rootFailure__a-BFQ","isDisabled":"CompleteLink_isDisabled__HFGvE"};